function initNavBannerClub() {
    const navBannerClub = document.querySelector(".nav-banner-club");

    if (!navBannerClub) {
        return;
    }

    const swiper = new Swiper(navBannerClub, {
        loop: false,
        grabCursor: true,
        slidesPerView: "auto",
        spaceBetween: 5,
        speed: 500,
        centerInsufficientSlides: true,
        freeMode: true,
        breakpoints: {
            // when window width is >= 320px
            768: {
                spaceBetween: 15,
            },
        }
    });
}